var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AFRAME } from "../../react/root";
import { GrabAndDropEvents, calculateEndPoint, customEventListener, getInputDevice, lerp3, setInputDevice, } from "../../react/systems/grabanddrop";
import { raiseCustomEvent } from "../../react/util";
export default function () {
    var THREE = window.THREE;
    AFRAME.registerComponent('draganddropzone', {
        schema: {
            width: { type: 'number' },
            height: { type: 'number' },
            depth: { type: 'number' },
        },
        init: function () {
            var me = this;
            var el = this.el;
            el.setAttribute('gui-interactable', {});
            customEventListener(GrabAndDropEvents.GRABBING_START, function (evt) {
                var _a;
                me.grabbing = true;
                var category = evt.category, deviceId = evt.deviceId;
                var size = getEntityBoundsAndSize(el).size;
                if ((_a = me === null || me === void 0 ? void 0 : me.imageCube) === null || _a === void 0 ? void 0 : _a.parentNode) {
                    me.imageCube.parentNode.removeChild(me.imageCube);
                }
                var imageCube = document.createElement('a-box');
                imageCube.setAttribute('gui-interactable', {});
                imageCube.addEventListener('raycaster-intersected', function (event) {
                    var device = setInputDevice(event);
                    if ((device === null || device === void 0 ? void 0 : device.id) === deviceId) {
                        var details = {
                            component: me,
                            deviceId: device.id
                        };
                        me.deviceId = device.id;
                        raiseCustomEvent(GrabAndDropEvents.GRAB_OVER, details);
                    }
                });
                imageCube.addEventListener('raycaster-intersected-cleared', function (event) {
                    var device = setInputDevice(event);
                    if ((device === null || device === void 0 ? void 0 : device.id) === deviceId) {
                        var details = {
                            component: me,
                            deviceId: device.id
                        };
                        delete me.deviceId;
                        raiseCustomEvent(GrabAndDropEvents.GRAB_OUT, details);
                    }
                });
                // let skin = 'assets/images/selection.png';
                // imageCube.setAttribute('src', `url(${skin})`)
                // imageCube.setAttribute('size', Math.min(size.x, size.y, size.z));
                imageCube.setAttribute('width', me.data.width || 1);
                imageCube.setAttribute('height', me.data.height || 1);
                imageCube.setAttribute('depth', me.data.depth || me.data.height || 1);
                imageCube.setAttribute('color', 'blue');
                var entity = document.createElement('a-entity');
                entity.appendChild(imageCube);
                me.el.appendChild(entity);
                me.imageCube = entity;
                // Listen for animation end to toggle
                entity.addEventListener('animationcomplete', function () {
                    if (entity.getAttribute('scale').x === 1) {
                        // If the entity has scaled up, scale it down
                        setScaleDownAnimation(entity);
                    }
                    else {
                        // If the entity has scaled down, scale it up
                        setScaleUpAnimation(entity);
                    }
                });
                setScaleUpAnimation(entity);
            });
            customEventListener(GrabAndDropEvents.GRABBING_ENDED, function (evt) {
                me.grabbing = false;
                if (me.imageCube && (evt.deviceId === me.deviceId || !me.deviceId)) {
                    me.imageCube.parentNode.removeChild(me.imageCube);
                    me.imageCube = null;
                }
            });
        }
    });
    AFRAME.registerComponent('spirit', {
        schema: {
            die: { type: 'boolean', default: false },
            alive: { type: 'boolean', default: false },
            device: { type: 'string', default: '' }
        },
        init: function () {
            var _this = this;
            var me = this;
            var el = this.el;
            el.addEventListener(GrabAndDropEvents.GRAB_TARGET_CHANGE, function (evt) { return __awaiter(_this, void 0, void 0, function () {
                var _a, component, deviceId;
                return __generator(this, function (_b) {
                    _a = evt.detail, component = _a.component, deviceId = _a.deviceId;
                    if (me.data.device === deviceId) {
                        me.targetComponent = component;
                    }
                    return [2 /*return*/];
                });
            }); });
        },
        tick: function () {
            var me = this;
            var nextpos = null;
            if (this.data.die) {
                return;
            }
            if (me.targetComponent) {
                var worldPosition = new THREE.Vector3();
                me.targetComponent.el.object3D.getWorldPosition(worldPosition);
                me.targetPoint = worldPosition;
            }
            else if (me.targetDevice) {
                var ray = me.targetDevice.getRay();
                if (ray === null || ray === void 0 ? void 0 : ray.ray) {
                    var _a = ray.ray, origin_1 = _a.origin, direction = _a.direction;
                    me.targetPoint = calculateEndPoint(origin_1, direction, 2);
                }
            }
            if (me.targetPoint) {
                var worldPosition = new THREE.Vector3();
                me.el.object3D.getWorldPosition(worldPosition);
                nextpos = lerp3(worldPosition, me.targetPoint, .07);
                me.el.setAttribute('position', "".concat(nextpos.x, " ").concat(nextpos.y, " ").concat(nextpos.z));
            }
        },
        appendChild: function (el) {
            // Append child entity or element
            this.el.appendChild(el);
        },
        update: function (oldData) {
            if (this.data.die) {
                this.el.parentNode.removeChild(this.el);
            }
            if (this.data.device !== oldData.device) {
                var inputDevice = getInputDevice(this.data.device);
                if (inputDevice) {
                    console.log(inputDevice);
                    this.targetDevice = inputDevice;
                }
            }
        }
    });
    AFRAME.registerPrimitive('a-spirit', {
        defaultComponents: {
            'spirit': {}
        },
        mappings: {
            //gui item general
            'die': 'spirit.die',
            'alive': 'spirit.alive',
            'device': 'spirit.device',
            // 'height': 'gui-item.height',
            // 'margin': 'gui-item.margin',
            // //gui timer specific
            // 'count-down': 'gui-circle-timer.countDown',
            // 'font-size': 'gui-circle-timer.fontSize',
            // 'font-family': 'gui-circle-timer.fontFamily',
            // 'font-color': 'gui-circle-timer.fontColor',
            // 'border-color': 'gui-circle-timer.borderColor',
            // 'background-color': 'gui-circle-timer.backgroundColor',
            // 'active-color': 'gui-circle-timer.activeColor',
            // 'callback': 'gui-interactable.clickAction',
        }
    });
    //changed name to spirit from ghost.
    function getEntityBoundsAndSize(entity) {
        // Ensure the entity is a valid A-Frame element
        if (!entity.object3D) {
            console.error('Invalid entity provided');
            return null;
        }
        // Create a new Box3 object, which represents the bounding box
        var boundingBox = new THREE.Box3().setFromObject(entity.object3D);
        // The size can be obtained from the bounding box
        var size = new THREE.Vector3();
        boundingBox.getSize(size);
        return {
            boundingBox: boundingBox,
            size: size
        };
    }
    // Function to set scaling up animation
    function setScaleUpAnimation(entity) {
        entity.setAttribute('animation', {
            property: 'scale',
            to: { x: 1.5, y: 1.5, z: 1.5 },
            dur: 1000,
        });
    }
    // Function to set scaling down animation
    function setScaleDownAnimation(entity) {
        entity.setAttribute('animation', {
            property: 'scale',
            to: { x: 1, y: 1, z: 1 },
            dur: 1000,
        });
    }
}
